import useTranslation from '../../hooks/useTranslation';
import { useSelector } from 'react-redux';
import timeFormAPI from '../../api/ui/timeFormAPI';
import { useEffect, useState } from 'react';
import { create } from './table-schema';
import { getNetworkTypeName, getWalletConnectionTypeName } from '../../constants/base';

function useSchemaWalletConnectionLog() {
  const { t } = useTranslation();
  const locale = useSelector((accountNo) => accountNo.language.locale);

  /**
   * 헤더에 표시할 항목의 개수
   */
  const size = 6;

  /**
   * 테이블 헤더에 표시할 항목 문자열 배열
   */
  const headerKeys = [
    "admin.log.user.walletConnectionLog.table.head.logNo", // "로그 번호",
    "admin.log.user.walletConnectionLog.table.head.accountNo", // "유저 ID",
    "admin.log.user.walletConnectionLog.table.head.networkType", // "유형",
    "admin.log.user.walletConnectionLog.table.head.status", // "연결 상태",
    "admin.log.user.walletConnectionLog.table.head.walletAddress", // "온체인 지갑 주소",
    "admin.log.user.walletConnectionLog.table.head.createdAt", // "로그 생성 시각",
  ];

  /**
   * 서버로부터 전달받은 request를 테이블에 표시할 내용으로 변환한다.
   *
   * 오브젝트 키는 param1, param10 등의 형식으로 param 다음에 숫자를 붙여서 사용한다.
   *
   * param1은 헤더의 첫번째 표시되는 항목이다.
   *
   * 헤더에는 표시되지 않지만 상세에 표시될 항목의 경우 headSize 이후의 숫자를 사용한다.
   *
   * key는 반드시 있어야 한다.
   * @param {object} row
   * @returns
   */
  const parse = (row) => {
    const index = row?.index;
    const logNo = row?.logNo;
    const accountNo = row?.accountNo;
    const networkType = getNetworkTypeName(row?.networkType);
    const status = getWalletConnectionTypeName(row?.status);
    const walletAddress = row?.walletAddress;
    const createdAt = timeFormAPI.changeDataLog(row?.createdAt);

    return {
      key: index, // 키는 반드시 있어야 한다.
      param1: logNo,
      param2: accountNo,
      param3: networkType,
      param4: status,
      param5: walletAddress,
      param6: createdAt,
      logNo: logNo,
    };
  };

  /**
   * 로그 데이터를 클릭했을 때 보여줄 디테일 다이얼로그에 보여줄 항목을 작성한다.
   *
   * 입력값인 row는 위의 parse에서 변환된 값이다.
   *
   * @param {object} row
   * @returns
   */
  const details = (row) => {
    const array = [];
    if (row) {
      //
    }
    return array;
  };

  const [schema, setSchema] = useState();

  useEffect(() => {
    const headers = headerKeys.map((key) => t(key));
    const schema = create({
      headSize: size,
      heads: headers,
      parseFunc: parse,
      detailFunc: details,
    });
    setSchema(schema);
  }, [locale]);

  return { schema: schema };
}

export default useSchemaWalletConnectionLog;
